import {
  DialogTitle as MuiDialogTitle,
  DialogTitleProps as MuiDialogTitleProps,
  styled,
} from "@mui/material";

const StyledDialogTitle = styled(MuiDialogTitle)(() => ({
  // ... existing styles
}));

interface DialogTitleProps extends MuiDialogTitleProps {
  children: React.ReactNode;
}

export const DialogTitle: React.FC<DialogTitleProps> = ({ children, ...props }) => {
  return <StyledDialogTitle {...props}> {children}</StyledDialogTitle>;
};

export default DialogTitle;
